module.exports = __webpack_public_path__ + "img/wmv.b544fb40.svg";